module.exports = __webpack_public_path__ + "static/media/draw-tutorial-4.debc8505.svg";